"use client"

import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Alert,
  CircularProgress,
  Box
} from '@mui/material';
import { Iconify } from '../iconify';
import axios from 'axios';
import { endpoints } from '@/utils/axios';

export function DisconnectSocialsButton() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleDisconnect = async () => {
    // if (!session) {
    //   setError('You are not logged in');
    //   return;
    // }

    setLoading(true);
    setError('');

    try {
      // const response = await fetch('/api/user/disconnect-social', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      // });

      const response = await axios.post(endpoints.meta.logoutFacebook, {}, {
        headers: { Authorization: `Bearer ${sessionStorage.jwt_access_token}` }
      })

      const data = response;
      console.log("response: ", data);

      // if (!response.ok) {
      //   throw new Error(data.error || 'Error disconnecting social accounts');
      // }

      setSuccess(true);

      setTimeout(() => {
        window.location.reload();
      }, 2000);

      // Sign out the user to clear the session
      // setTimeout(async () => {
      //   await signOut({ redirect: false });
      //   window.location.reload();
      // }, 2000);

    } catch (err) {
      setError(err.message || 'Error disconnecting social accounts');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setOpen(false);
      setError('');
      setSuccess(false);
    }
  };

  // if (!session) {
  //   return (
  //     <Alert severity="info" sx={{ mt: 3 }}>
  //       To delete your data, please log in to your account first.
  //     </Alert>
  //   );
  // }

  return (
    <Box sx={{ mt: 4 }}>
      <Button
        variant="contained"
        color="error"
        size="large"
        startIcon={<Iconify icon="solar:logout-2-bold" />}
        onClick={() => setOpen(true)}
        sx={{ minWidth: 200 }}
      >
        Disconnect Social Accounts
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Disconnect Social Accounts
        </DialogTitle>

        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Your Facebook and Instagram accounts have been disconnected successfully. Refreshing...
            </Alert>
          )}

          {!success && (
            <>
              <Typography variant="body1" paragraph>
                Are you sure you want to disconnect your Facebook and Instagram accounts?
              </Typography>

              <Typography variant="body2" color="text.secondary" paragraph>
                This action will:
              </Typography>

              <Typography component="ul" variant="body2" color="text.secondary" sx={{ pl: 2 }}>
                <li>Remove Facebook and Instagram access tokens</li>
                <li>Disconnect your social media accounts</li>
                <li>Stop automatic data synchronization</li>
              </Typography>

              <Alert severity="info" sx={{ mt: 2 }}>
                <strong>Note:</strong> You can reconnect your accounts anytime by logging in again.
              </Alert>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>

          {!success && (
            <Button
              onClick={handleDisconnect}
              color="error"
              variant="contained"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={20} /> : <Iconify icon="solar:logout-2-bold" />}
            >
              {loading ? 'Disconnecting...' : 'Disconnect Accounts'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
}